export default {
  methods: {
    onFocus ($event) {
      this.$emit('focus-change', $event)
    },
    onBlur ($event) {
      this.$emit('focus-lose', null)
    },
    setInput (propertyPath, value) {
      const propertyPathEntries = propertyPath.split(".")
      const lastEntry = propertyPathEntries.pop()
      let property = this
      for (const entry of propertyPathEntries) {
        if (property[entry] === undefined) {
          property[entry] = {}
        }
        property = property[entry]
      }
      property[lastEntry] = value
    },
    getInput (propertyPath) {
      const propertyPathEntries = propertyPath.split(".")
      const lastEntry = propertyPathEntries.pop()
      let property = this
      for (const entry of propertyPathEntries) {
        if (property[entry] === undefined) {
          property[entry] = {}
        }
        property = property[entry]
      }
      return property[lastEntry]
    }
  }
}
